export default __webpack_public_path__ + "static/john and regina wallace-0295ce7f73abc63e3fb359463dee7c91.webp";